import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import toast from "./plugins/toast";
import "./style.css";
import "./plugins/money-humanize";

Vue.config.productionTip = false;

Vue.prototype.$overlay = (value) => {
  store.state.overlay = value;
};

new Vue({
  router,
  store,
  toast,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
